import React, { ReactNode } from 'react';
import { Divider } from '@material-ui/core';

import { jsxJoin } from 'utils/jsxJoin';

import useStyles from './styles';

export interface DonatePageSectionProps {
  title: string;
  value: string | ReactNode;
  tooltip?: ReactNode;
}
export const DonatePageSection = ({
  title,
  value,
  tooltip,
}: DonatePageSectionProps): JSX.Element => {
  const styles = useStyles();
  return (
    <div className={styles.DonatePageSection}>
      <div className={styles.main}>
        <div className={styles.title}>{title}</div>
        <div className={styles.value}>{value}</div>
      </div>

      {tooltip}
    </div>
  );
};

export const DonatePageSections = ({ children }: { children: React.ReactNode[] }): JSX.Element =>
  jsxJoin(children, (key) => <Divider key={key} />);

export default DonatePageSection;
